var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowUpgradeCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06154 7.25345L9.81779 11.4384L14.0553 6.22095C14.1739 6.07508 14.324 5.95787 14.4942 5.87803C14.6645 5.7982 14.8505 5.7578 15.0385 5.75984C15.2266 5.76188 15.4117 5.80632 15.5802 5.88983C15.7486 5.97335 15.8961 6.09379 16.0115 6.2422L20.0553 11.4372L24.9653 7.1922C25.1581 7.02583 25.3971 6.92233 25.6504 6.89555C25.9036 6.86876 26.159 6.91997 26.3824 7.04232C26.6057 7.16467 26.7864 7.35231 26.9002 7.58015C27.0139 7.80799 27.0554 8.06514 27.019 8.3172L25.144 21.2509H4.90279L2.99904 8.37595C2.96122 8.12249 3.00222 7.86354 3.11648 7.63416C3.23073 7.40478 3.41273 7.21606 3.63781 7.09356C3.8629 6.97106 4.12019 6.92069 4.37485 6.94929C4.62951 6.97789 4.86923 7.08407 5.06154 7.25345ZM5.00029 22.5009H25.0003V23.7509C25.0003 24.0825 24.8686 24.4004 24.6342 24.6348C24.3998 24.8692 24.0818 25.0009 23.7503 25.0009H6.25029C5.91877 25.0009 5.60082 24.8692 5.3664 24.6348C5.13198 24.4004 5.00029 24.0825 5.00029 23.7509V22.5009Z",
    fill: "#FFB944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowUpgradeCrown);
export default __webpack_public_path__ + "static/media/YellowUpgradeCrown.f156851123e86533fd09f03441bb4a51.svg";
export { ForwardRef as ReactComponent };